export enum StatusTAEnum {
  NAO_INFORMADO,
  ELABORACAO,
  PUBLICADO,
  CANCELADO,
}

// Mapeamento para exibição
export const StatusTALabels: Record<StatusTAEnum, string> = {
  [StatusTAEnum.NAO_INFORMADO]: 'Não informado',
  [StatusTAEnum.ELABORACAO]: 'Em elaboração',
  [StatusTAEnum.PUBLICADO]: 'Publicado',
  [StatusTAEnum.CANCELADO]: 'Cancelado',
};

// Mapeamento para códigos/slugs
export const StatusTACodes: Record<StatusTAEnum, string> = {
  [StatusTAEnum.NAO_INFORMADO]: '',
  [StatusTAEnum.ELABORACAO]: 'E',
  [StatusTAEnum.PUBLICADO]: 'P',
  [StatusTAEnum.CANCELADO]: 'C',
};

export const getStatusTAOptions = () => {
  return Object.values(StatusTAEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      value: value as StatusTAEnum,
      label: StatusTALabels[value as StatusTAEnum],
      code: StatusTACodes[value as StatusTAEnum],
    }));
};

export const getStatusTASlug = (statusTA: StatusTAEnum): string => {
  return StatusTACodes[statusTA] || 'Desconhecido';
};

export const getStatusTALabel = (statusTA: StatusTAEnum): string => {
  return StatusTALabels[statusTA] || 'Status desconhecido';
};

export const getStatusTAPorCodigo = (
  code: string,
): StatusTAEnum | undefined => {
  const entry = Object.entries(StatusTACodes).find(
    ([, value]) => value === code,
  );
  return entry ? (Number(entry[0]) as StatusTAEnum) : undefined;
};

export const getStatusTALabelPorSlug = (slug: string): string => {
  const statusTA = getStatusTAPorCodigo(slug);

  if (statusTA !== undefined) {
    return getStatusTALabel(statusTA);
  }

  return 'Status desconhecido';
};
